import { render, staticRenderFns } from "./DlgConfirmDelete.vue?vue&type=template&id=7ccc8b8d&scoped=true"
import script from "./DlgConfirmDelete.vue?vue&type=script&lang=ts"
export * from "./DlgConfirmDelete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccc8b8d",
  null
  
)

export default component.exports